// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Mamahood marketing header — used by MamahoodMarketingHeader.jsx.
 * Self-contained tokens + pills so Collective (and other) routes work without loading full MamahoodHomepage.css.
 */

:root {
  --cream: #efe4d3;
  --coral: #e57257;
  --text: #433d43;
  --teal: #6f9f9a;
  --mint: #8eb9b2;
  --gold: #d8b04e;
  --shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  --shadow-hover: 0 14px 40px rgba(0, 0, 0, 0.12);
  --ease-out: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  --transition-fast: 180ms var(--ease-out);
  --transition-base: 220ms var(--ease-out);
  --focus-ring: 2px solid var(--teal);
  --focus-ring-offset: 2px;
  --mh-font-display: "fabulosa", serif;
}

/* Join pill in header (subset of homepage .mh-pill) */
.mh-header .mh-pill {
  border: none;
  border-radius: 999px;
  padding: 13px 26px;
  cursor: pointer;
  background: var(--coral);
  color: #fff;
  font-weight: 700;
  box-shadow: var(--shadow);
  transition:
    transform var(--transition-base),
    box-shadow var(--transition-base),
    color var(--transition-fast);
}

.mh-header .mh-pill:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-hover);
}

.mh-header .mh-pill:active {
  transform: translateY(0);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.mh-header .mh-pill:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.mh-header .mh-pill--small {
  padding: 10px 18px;
  font-size: 0.9rem;
}

.mh-header a.mh-pill {
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

/* Header */
.mh-header {
  background: var(--cream);
  position: relative;
  z-index: 10;
}

.mh-header__top {
  /* Container-owned vertical sizing; override from JSX via style or height / headerPaddingY props */
  --mh-header-height: 6rem;
  --mh-header-padding-y: 0px;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  /* Allocate extra vertical space to the nav row so the white strip fills to the bottom of this block (inside padding). */
  min-height: var(--mh-header-height);
  padding: var(--mh-header-padding-y) 0px;
  gap: 10px;
  overflow: visible;
  box-sizing: border-box;
}

.mh-header__nav-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  background: #fff;
  padding: 12px 16px;
  box-sizing: border-box;
  gap: 12px;
}

.mh-header__nav-row > .mh-nav {
  flex: 1 1 auto;
  min-width: 0;
  justify-content: center;
}

.mh-socials {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex: 0 0 auto;
}

.mh-socials__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--mint);
  color: #fff;
  font-size: 14px;
  text-decoration: none;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.mh-socials__icon:hover {
  transform: translateY(-1px);
  opacity: 0.85;
}

.mh-socials__icon:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.mh-brand {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: center;
  flex: 0 0 auto;
  min-height: 0;
  text-align: center;
  color: inherit;
  text-decoration: none;
}

.mh-brand:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
  border-radius: 4px;
}

.mh-brand__mark {
  position: absolute;
  margin-top: 30px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
  font-size: 6.25rem;
  line-height: 1;
  color: rgba(111, 159, 154, 0.35);
  font-family: var(--mh-font-display);
}

.mh-brand__name {
  position: relative;
  z-index: 1;
  margin-top: 30px;
  font-size: 1.531rem;
  font-weight: 700;
  letter-spacing: 0.26em;
}

.mh-header__actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 0 0 auto;
}

.mh-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--mint);
  display: grid;
  place-items: center;
  transition: opacity var(--transition-fast), transform var(--transition-fast);
}

.mh-avatar:hover {
  opacity: 0.9;
  transform: scale(1.05);
}

.mh-avatar:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.mh-nav {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  background: transparent;
  padding: 0;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.625rem;
  font-weight: 700;
}

.mh-nav a.mh-nav__link {
  color: var(--text);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.mh-nav a.mh-nav__link:hover {
  color: var(--teal);
}

.mh-nav a.mh-nav__link:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
  border-radius: 2px;
}

.mh-nav a.mh-nav__link--active {
  color: var(--teal);
  text-decoration: underline;
  text-underline-offset: 0.2em;
}

@media (max-width: 768px) {
  .mh-socials {
    display: none;
  }

  .mh-header__nav-row {
    justify-content: space-between;
    padding: 12px 12px;
  }

  .mh-nav {
    gap: 18px;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/components/navigation/MamahoodMarketingHeader.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,yCAAyC;EACzC,+CAA+C;EAC/C,gDAAgD;EAChD,wCAAwC;EACxC,wCAAwC;EACxC,mCAAmC;EACnC,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA,sDAAsD;AACtD;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB;;;gCAG8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kGAAkG;EAClG,wBAAwB;EACxB,0BAA0B;;EAE1B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wHAAwH;EACxH,mCAAmC;EACnC,uCAAuC;EACvC,SAAS;EACT,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;AACF","sourcesContent":["/*\n * Mamahood marketing header — used by MamahoodMarketingHeader.jsx.\n * Self-contained tokens + pills so Collective (and other) routes work without loading full MamahoodHomepage.css.\n */\n\n:root {\n  --cream: #efe4d3;\n  --coral: #e57257;\n  --text: #433d43;\n  --teal: #6f9f9a;\n  --mint: #8eb9b2;\n  --gold: #d8b04e;\n  --shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  --shadow-hover: 0 14px 40px rgba(0, 0, 0, 0.12);\n  --ease-out: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  --transition-fast: 180ms var(--ease-out);\n  --transition-base: 220ms var(--ease-out);\n  --focus-ring: 2px solid var(--teal);\n  --focus-ring-offset: 2px;\n  --mh-font-display: \"fabulosa\", serif;\n}\n\n/* Join pill in header (subset of homepage .mh-pill) */\n.mh-header .mh-pill {\n  border: none;\n  border-radius: 999px;\n  padding: 13px 26px;\n  cursor: pointer;\n  background: var(--coral);\n  color: #fff;\n  font-weight: 700;\n  box-shadow: var(--shadow);\n  transition:\n    transform var(--transition-base),\n    box-shadow var(--transition-base),\n    color var(--transition-fast);\n}\n\n.mh-header .mh-pill:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-hover);\n}\n\n.mh-header .mh-pill:active {\n  transform: translateY(0);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n}\n\n.mh-header .mh-pill:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n}\n\n.mh-header .mh-pill--small {\n  padding: 10px 18px;\n  font-size: 0.9rem;\n}\n\n.mh-header a.mh-pill {\n  text-decoration: none;\n  display: inline-block;\n  text-align: center;\n}\n\n/* Header */\n.mh-header {\n  background: var(--cream);\n  position: relative;\n  z-index: 10;\n}\n\n.mh-header__top {\n  /* Container-owned vertical sizing; override from JSX via style or height / headerPaddingY props */\n  --mh-header-height: 6rem;\n  --mh-header-padding-y: 0px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  /* Allocate extra vertical space to the nav row so the white strip fills to the bottom of this block (inside padding). */\n  min-height: var(--mh-header-height);\n  padding: var(--mh-header-padding-y) 0px;\n  gap: 10px;\n  overflow: visible;\n  box-sizing: border-box;\n}\n\n.mh-header__nav-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  flex: 1 1 auto;\n  min-height: 0;\n  background: #fff;\n  padding: 12px 16px;\n  box-sizing: border-box;\n  gap: 12px;\n}\n\n.mh-header__nav-row > .mh-nav {\n  flex: 1 1 auto;\n  min-width: 0;\n  justify-content: center;\n}\n\n.mh-socials {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  flex: 0 0 auto;\n}\n\n.mh-socials__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--mint);\n  color: #fff;\n  font-size: 14px;\n  text-decoration: none;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n.mh-socials__icon:hover {\n  transform: translateY(-1px);\n  opacity: 0.85;\n}\n\n.mh-socials__icon:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n}\n\n.mh-brand {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n  flex: 0 0 auto;\n  min-height: 0;\n  text-align: center;\n  color: inherit;\n  text-decoration: none;\n}\n\n.mh-brand:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n  border-radius: 4px;\n}\n\n.mh-brand__mark {\n  position: absolute;\n  margin-top: 30px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 0;\n  font-size: 6.25rem;\n  line-height: 1;\n  color: rgba(111, 159, 154, 0.35);\n  font-family: var(--mh-font-display);\n}\n\n.mh-brand__name {\n  position: relative;\n  z-index: 1;\n  margin-top: 30px;\n  font-size: 1.531rem;\n  font-weight: 700;\n  letter-spacing: 0.26em;\n}\n\n.mh-header__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex: 0 0 auto;\n}\n\n.mh-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: var(--mint);\n  display: grid;\n  place-items: center;\n  transition: opacity var(--transition-fast), transform var(--transition-fast);\n}\n\n.mh-avatar:hover {\n  opacity: 0.9;\n  transform: scale(1.05);\n}\n\n.mh-avatar:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n}\n\n.mh-nav {\n  display: flex;\n  justify-content: center;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n  background: transparent;\n  padding: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  font-size: 0.625rem;\n  font-weight: 700;\n}\n\n.mh-nav a.mh-nav__link {\n  color: var(--text);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.mh-nav a.mh-nav__link:hover {\n  color: var(--teal);\n}\n\n.mh-nav a.mh-nav__link:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n  border-radius: 2px;\n}\n\n.mh-nav a.mh-nav__link--active {\n  color: var(--teal);\n  text-decoration: underline;\n  text-underline-offset: 0.2em;\n}\n\n@media (max-width: 768px) {\n  .mh-socials {\n    display: none;\n  }\n\n  .mh-header__nav-row {\n    justify-content: space-between;\n    padding: 12px 12px;\n  }\n\n  .mh-nav {\n    gap: 18px;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
